import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import AuthStore from '@/stores/authStore';
import UserStore from '@/stores/userStore';
import JobsStore from '@/stores/jobsStore';
import NavigationStore from '@/stores/navigationStore';

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage, // Where to persist the data (localStorage, sessionStorage, etc)
  modules: ['auth'] // Which modules will have their store state persisted
})

export const store = new Vuex.Store({
  plugins: [
    vuexLocal.plugin
  ],
  modules: {
    auth: AuthStore.ExtractVuexModule(AuthStore),
    user: UserStore.ExtractVuexModule(UserStore),
    jobs: JobsStore.ExtractVuexModule(JobsStore),
    navigation: NavigationStore.ExtractVuexModule(NavigationStore)
  }
});

export const vxm = {
  auth: AuthStore.CreateProxy(store, AuthStore),
  user: UserStore.CreateProxy(store, UserStore),
  jobs: JobsStore.CreateProxy(store, JobsStore),
  navigation: NavigationStore.CreateProxy(store, NavigationStore)
};
